import { useRef as useReactRef } from 'react';
export var useRootRef = function useRootRef(ref) {
  var localRef = useReactRef();
  return ref || localRef;
};